import template from './quickbooks.html';
import controller from './quickbooks.controller';

let quickbooksComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default quickbooksComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/quickbooks.component.js